import { render, staticRenderFns } from "./WebhooksListCreate.vue?vue&type=template&id=6bcfe196"
import script from "./WebhooksListCreate.vue?vue&type=script&lang=js"
export * from "./WebhooksListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports